export const purchaseParticipantType = [{
  value: 'Undefined', label: 'Undefined', color: 'red'
}, {
  value: 'Organizer', label: 'Organizer', color: 'green'
}, {
  value: 'Player', label: 'Player', color: 'blue'
}, {
  value: 'Spectator', label: 'Spectator', color: 'yellow'
}];